const externalRules = {
  required: (value) => {
    if (value instanceof Array && value.length === 0) {
      return 'Wymagane';
    }
    return typeof value === 'number' ? true : (!!value || 'Wymagane');
  },
  email: (value) => {
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return pattern.test(value) || 'Niepoprawny e-mail';
  },
  password: (value) => {
    const pattern = /^(?=.*\d)(?=.*[!@#$%^&=\-*(<_+>);?:"{}',./[\]])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
    return pattern.test(value) || 'Wymagania dla hasła: co najmniej 8 znaków, mała litera, wielka litera, cyfra, znak specjalny';
  },
  url: (value) => {
    const pattern = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,})/gi;
    return pattern.test(value) || 'Poprawny format url to https://nbp.pl';
  },
  match: (match) => (value) => value === match || 'Podane hasła różnią się',

  maxLength: (max) => (value) => value.length <= max || `Maksymalna liczba znaków: ${max}`,

  lowerThan: (amount) => (value) => {
    if (typeof value !== 'number') return true
    return value < amount || `Zbyt wysoka wartość (Maks. ${amount - 1})`
  },

  objectEmpty: (obj) => Object.keys(obj).length !== 0 || 'Wymagane',
};

export default externalRules;
